"use client";

import Skeleton from "@/components/ui/Skeleton";
import { SetStateAction, Suspense, useState } from "react";
import styles from "./media-gallery.module.css";

import Video from "@/components/ui/Video";
import ZoomDialog from "@/components/ui/ZoomImage/ZoomDialog";
import ZoomImage from "@/components/ui/ZoomImage/ZoomImage";
import useDevice from "@/hooks/useDevice";
import { sizes } from "@/lib/utils/imageSizes";
import clsx from "clsx";
import { Controller } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useProductContext } from "../../ProductProvider";

const SwiperGallery = ({ className }: { className?: string }) => {
  const [current, setCurrent] = useState(0);
  const { activeVariant } = useProductContext();
  const { mobile } = useDevice();
  const [zoom, setZoom] = useState(false);

  const [firstSwiper, setFirstSwiper] = useState<any>(null);
  const [secondSwiper, setSecondSwiper] = useState<any>(null);

  let media = [];
  if (mobile) {
    media = activeVariant?.media ?? [];
  } else {
    media = activeVariant?.media?.filter((image) => !image.isPackshot) ?? [];
  }

  return (
    <>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        scrollbar={{ draggable: true }}
        navigation
        pagination
        zoom={true}
        onSlideChange={(swiper) => {
          setCurrent(swiper.activeIndex);
        }}
        className={clsx(className, styles.swiper)}
        onSwiper={setFirstSwiper}
        modules={[Controller]}
        controller={{ control: secondSwiper }}
      >
        {media?.map((image, i: number) => (
          <SwiperSlide
            className={styles.slide}
            key={i}
            onClick={() => setZoom(true)}
          >
            {image.type === "image" ? (
              <>
                <ZoomImage
                  setZoom={setZoom}
                  setCurrent={setCurrent}
                  current={current}
                  media={media}
                  src={image.href}
                  alt=""
                  fill
                  className={styles["image-swiper"]}
                  sizes={sizes(100, 60)}
                  loading={"eager"}
                  quality={100}
                />
              </>
            ) : (
              <div className={styles.video}>
                <Suspense fallback={<Skeleton height="100%" />}>
                  <Video
                    url={image.href}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />
                </Suspense>
              </div>
            )}
          </SwiperSlide>
        ))}
        {!media && (
          <SwiperSlide className={styles.slide}>
            <div className="sr-only">No image found</div>
          </SwiperSlide>
        )}
        <div className={styles.count}>
          {current + 1} / {media?.length}
        </div>
      </Swiper>
      {zoom && (
        <Suspense>
          <ZoomDialog
            setCurrent={setCurrent}
            current={current}
            media={media}
            setOpen={setZoom}
            setSecondSwiper={setSecondSwiper}
            firstSwiper={firstSwiper}
            src={""}
            alt={""}
            setZoom={function (value: SetStateAction<boolean>): void {
              throw new Error("Function not implemented.");
            }}
          />
        </Suspense>
      )}
    </>
  );
};
export default SwiperGallery;
